import { getPanelPreview } from "~/containers/LegacyDesigner/Studio/Overlays/PreviewPanel"

import type { TransactionOperation } from "."
import { addOnePanel } from "."

export const clickCreatePanel: TransactionOperation = (transactors) => {
  const previewPanel = getPanelPreview(transactors)
  if (previewPanel) {
    addOnePanel(transactors, previewPanel)
  }
}
